/** Класс на `<html>`, по которому index.css делает скроллбары тонкими и прозрачными до наведения. */
export const CLASSIC_SCROLLBARS_CLASS = 'sloy-classic-scrollbars';

/**
 * Отмечает браузер с классическими скроллбарами — они занимают место и видны всегда (Windows,
 * Linux, macOS с «Показывать полосы прокрутки: всегда»). Оверлейные скроллбары macOS места не
 * занимают: там класс не ставится и вид скроллбаров не меняется.
 */
export function markClassicScrollbars(): void {
  const probe = document.createElement('div');
  probe.style.cssText =
    'position:absolute;top:-9999px;width:100px;height:100px;overflow:scroll;visibility:hidden';
  document.body.appendChild(probe);
  const classic = probe.offsetWidth - probe.clientWidth > 0;
  probe.remove();
  document.documentElement.classList.toggle(CLASSIC_SCROLLBARS_CLASS, classic);
}
